/**
 * Owner: Masa Bayu
 * File: create-demo-taxonomy.ts
 * Date:Time: 2026-09-15 21:14
 * Description: T2 demo categories/collections over demo catalog (indexes only).
 */

import {
  createQxreadTaxonomyIndex,
  createQxreadTaxonomyNode,
  deriveCategoriesFromCatalog,
  type QxreadTaxonomyIndex,
} from '@qx/qxread-core';
import { createDemoCatalog } from '../publication/create-demo-catalog';

export function createDemoTaxonomyIndex(): QxreadTaxonomyIndex {
  const catalog = createDemoCatalog();
  const categories = deriveCategoriesFromCatalog(catalog);
  const publicationIds = catalog.map((entry) => entry.publicationId);
  const collections = Object.freeze([
    createQxreadTaxonomyNode({
      taxonomyId: 'qxrdtax_col_featured_week',
      kind: 'collection',
      slug: 'featured-this-week',
      label: 'Featured this week',
      publicationIds,
    }),
    createQxreadTaxonomyNode({
      taxonomyId: 'qxrdtax_col_maps_desk',
      kind: 'collection',
      slug: 'maps-desk',
      label: 'Maps desk',
      publicationIds: catalog
        .filter((entry) => {
          const tags = Array.isArray(entry.metadata.tags) ? entry.metadata.tags : [];
          return tags.includes('maps');
        })
        .map((entry) => entry.publicationId),
    }),
  ]);
  return createQxreadTaxonomyIndex({ categories, collections });
}
